import { msg } from "@lingui/core/macro";
import { useLingui } from "@lingui/react";
import { HeartPulse } from "lucide-react";

import { formatGameTime } from "../format/formatGameTime";
import { formatList } from "../format/formatList";
import { FindingCard } from "./FindingCard";
import type { FindingProps } from "./FindingProps";
import { iconSize } from "./iconSize";
import { IconBadge } from "./IconBadge";

const TITLE = msg({
  id: "finding.low_hp_survival",
  message: "{count, plural, one {Survived} other {Survived # times}} at almost zero HP",
});

const DETAILS = msg({
  id: "finding.low_hp_survival.details",
  message: "An enemy right next to you, {hp}% HP left — and no death. When: {times}.",
});

// Сильная сторона: уходил живым с почти нулевым HP, когда враг был рядом.
export const LowHpSurvival = ({ finding, variant }: FindingProps<"low_hp_survival">) => {
  const { i18n } = useLingui();
  const { times_s: timesS, min_health: health } = finding.params;
  const hp = Math.min(...health);
  const times = formatList(timesS.map(formatGameTime), i18n.locale);
  const details = i18n._({ ...DETAILS, values: { hp, times } });
  return (
    <FindingCard
      code={finding.code}
      severity={finding.severity}
      variant={variant}
      icon={<IconBadge icon={HeartPulse} size={iconSize(variant)} />}
      title={i18n._({ ...TITLE, values: { count: timesS.length } })}
      details={details}
      summary={times}
    />
  );
};
